// Teste de configuração do frontend
// Este arquivo será executado no browser para verificar qual ID está sendo usado

import { ADMIN_CONFIG } from './config/admin.js';

console.log('🔍 TESTE DE CONFIGURAÇÃO DO FRONTEND');
console.log('=====================================');
console.log('📍 Configuração carregada:');
console.log('✅ ADMIN_USER_ID:', ADMIN_CONFIG.ADMIN_USER_ID);
console.log('✅ ADMIN_EMAIL:', ADMIN_CONFIG.ADMIN_EMAIL);
console.log('✅ BASE_URL:', ADMIN_CONFIG.API.BASE_URL);

// Testar se o ID está correto
const expectedId = 'bd52acbe-1b3c-4606-a2f5-0c7bd143fe31';
const actualId = ADMIN_CONFIG.ADMIN_USER_ID;

if (actualId === expectedId) {
  console.log('🎉 ID CORRETO! Configuração está funcionando');
} else {
  console.log('❌ ID INCORRETO!');
  console.log('   Esperado:', expectedId);
  console.log('   Atual:', actualId);
}

// Testar URL da API
const apiUrl = ADMIN_CONFIG.API.BASE_URL + ADMIN_CONFIG.API.ENDPOINTS.ADMIN_USERS;
console.log('🔗 URL da API:', apiUrl);

// Testar URL completa com ID
const fullUrl = `${apiUrl}?select=*&id=eq.${actualId}`;
console.log('🔗 URL completa:', fullUrl);

// Verificar se há ID incorreto no código
if (actualId.includes('9cd08c49')) {
  console.log('🚨 ALERTA: ID incorreto encontrado no código!');
} else {
  console.log('✅ Nenhum ID incorreto encontrado no código');
}

export { ADMIN_CONFIG };
